registerComponent("product-blocks/product-manager", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * ⚠️ ESTE OUVINTE NÃO TEM COMO DISPARAR HOJE, e não é descuido de transposição:
 * ele está aqui porque o markup que o alimentava continua no Blade, só que
 * desligado. São duas camadas, cada uma suficiente sozinha:
 *
 * 1. O bloco `.col-video` inteiro está atrás de `@if(false AND
 *    $data['product']->video_report)` desde o commit `447b6885` (16/06/2025) —
 *    o `false` foi escrito à mão, o resto da condição ficou.
 * 2. Mesmo com o `false` removido, `.box-video` traz um `<iframe>` do YouTube,
 *    não um `<video>`: o `<video src="…/home.mp4">` que este seletor casava
 *    saiu do markup ainda em 2023. O `play` de um `<iframe>` não existe, e o
 *    `postMessage` da API do YouTube nunca foi ligado aqui.
 *
 * Transposto assim mesmo — e não apagado — porque o Blade não muda nesta
 * reescrita (front-only) e reativar o bloco é um `false` a menos: apagar o
 * ouvinte perderia o `video_report` do GA sem que ninguém percebesse. O achado
 * está no relatório do sub-lote 8c.
 */

// `$document.trigger('remoteTrack', ['video_report', 'video_play'])` →
// `Asa.rastrear`, que é o mesmo `dataLayer.push` com as quatro chaves passadas
// por `slug()`. A guarda `?.` é a de 2020: fundo sem vídeo do gestor não tem o
// elemento, e sem ela o componente estoura e derruba a inicialização dos
// seguintes.
component.querySelector('.box-video video')?.addEventListener('play', function () {
    Asa.rastrear('video_report', 'video_play');
});

});
